import { classNames as cn } from "primereact/utils";
import React, { ReactNode } from "react";

import { emptyStateImages, WSEmptyStateType } from "../../emptyStates";
import { WSButton, WSButtonProps } from "../core/WSButton/WSButton.component";
import { WSText } from "../core/WSText/WSText.component";
import { WSFlexBox } from "../layout";
import {
  WSElement,
  WSMarginProps,
  WSPaddingProps
} from "../WSElement/WSElement.component";

import styles from "./WSPoster.module.scss";


export interface WSPosterProps extends WSMarginProps, WSPaddingProps {
  type: WSEmptyStateType;
  title: string;
  description?: string | ReactNode;
  className?: string;
  buttons?: WSButtonProps[];
  align?: "left" | "center" | "right";
  size?: "S" | "M";
  bgColor?: "transparent" | "white" | "gray";
  theme?: "neutral" | "garnet";
}

export const WSPoster: React.FC<WSPosterProps> = ({
  type,
  bgColor = "transparent",
  theme = "neutral",
  align = "left",
  size = "M",

  title,
  description,
  buttons,
  className,
  ...otherProps
}) => {
  const SVG = emptyStateImages[theme][type];
  return (
    <WSElement
      px="M"
      py="L"
      className={cn(
        styles[`bg-${bgColor}`],
        styles[`align-${align}`],
        className
      )}
      {...otherProps}
    >
      <WSFlexBox.CenterY direction="row" className={cn(styles.container)}>
        <SVG className={cn(styles.img, styles[`img-${size}`])} />
        <WSFlexBox
          ml="XS"
          direction="column"
          className={cn(styles.textContent)}
        >
          <WSText
            kind={size === "M" ? "Heading5" : "Paragraph"}
            className={styles.wordBreak}
            mb="XS"
            color="gray600"
            weight="medium"
          >
            {title}
          </WSText>
          {description && (
            <WSText.ParagraphSm
              className={styles.description}
              align={"left"}
              mb={"M"}
              color="gray600"
              weight="book"
            >
              {description}
            </WSText.ParagraphSm>
          )}
          {buttons?.map((button, index) => (
            <WSButton
              className={styles.button}
              size={size === "M" ? "M" : "S"}
              key={button.label}
              {...button}
            />
          ))}
        </WSFlexBox>
      </WSFlexBox.CenterY>
    </WSElement>
  );
};
